import { useDownloadFile } from '@newfront-insurance/admin-ui/files';
import { cn } from '@newfront-insurance/core-ui/v2';

import type { SandboxFile } from '../lib/sources';

interface SandboxFileLinkProps {
  filename: string;
  children: React.ReactNode;
  sandboxFileMap: Map<string, SandboxFile>;
}

/**
 * Renders a sandbox file link as a clickable download trigger.
 * Shows a loading/disabled state until the source-document arrives with the fileUuid,
 * then transitions to a clickable link that triggers file download.
 */
export function SandboxFileLink({ filename, children, sandboxFileMap }: SandboxFileLinkProps) {
  const fileData = sandboxFileMap.get(filename);
  const { download, isDownloading } = useDownloadFile({});
  const isLoading = !fileData;
  const content = isLoading ? 'Generating...' : children;

  const handleClick = () => {
    if (fileData) {
      download(fileData.fileUuid);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isLoading || isDownloading}
      className={cn('text-brand-400 hover:underline', {
        'opacity-50': isDownloading,
        'animate-pulse cursor-default': isLoading,
      })}
    >
      {content}
    </button>
  );
}
